module.exports = __webpack_public_path__ + "img/pres.bb1ce7b3.png";